import { Client } from "@core/Client";
import { HistorySnapshot } from "@core/Logic/Links/IMAXA/IMAXAProtocol";
import { PresetCoordinate } from "@core/Logic/Logic";
import { RouletteHistorySnapshot } from "BaseRoulette/Sources/Logic/Links/IMAXA/IMAXAProtocol";
import { GameObjects } from "phaser";
import { Constants } from "./Constants";

export function FindMinInArray(arr: Array<number>): number {
	return arr[IndexOfMinInArray(arr)];
}

//helper function to find Min number in array
export function IndexOfMinInArray(arr: Array<number>): number {
	let min: number = 0;
	for (let index = 1; index < arr.length; index++) {
		if (arr[index] < arr[min])
			min = index;
	}
	return min;
}

export function FindMaxInArray(arr: Array<number>): number {
	return arr[IndexOfMaxInArray(arr)];
}

//helper function to find Min number in array
export function IndexOfMaxInArray(arr: Array<number>): number {
	let max: number = 0;
	for (let index = 1; index < arr.length; index++) {
		if (arr[index] > arr[max])
			max = index;
	}
	return max;
}

export function GetParameterByName(name: string, ifNotExists: string = ''): string {
	let match = RegExp('[?&]' + name + '=([^&]*)').exec(GetQueryString())
	if (match) {
		return decodeURIComponent(match[1].replace(/\+/g, ' '))
	} else {
		return ifNotExists;
	}
}

export function GetQueryString(skipParameters?: string[]): string {
	let mainScriptElement = document.getElementById("mainGame").getAttribute("src")
	// return mainScriptElement.indexOf("?") == -1 ? GetWindowQuery() : mainScriptElement.substr(mainScriptElement.indexOf("?"))
	let params = mainScriptElement.indexOf("?") == -1 ? GetWindowQuery() : mainScriptElement.substr(mainScriptElement.indexOf("?"))
	if (skipParameters) {
		for (let i = 0; i < skipParameters.length; i++) {
			params = removeURLParameter(params, skipParameters[i])
		}
	}
	return params
}

export function GetWindowQuery(): string {
	return window.location.search.indexOf("?") == -1 ? "" : window.location.search.substr(window.location.search.indexOf("?"))
}

function removeURLParameter(url: string, param: string): string {
	let urlparts = url.split('?')
	if (urlparts.length >= 2) {
		let prefix = encodeURIComponent(param) + '='
		let pars = urlparts[1].split(/[&;]/g)
		for (let i = pars.length; i-- > 0;)
			if (pars[i].indexOf(prefix, 0) == 0) pars.splice(i, 1)
		if (pars.length > 0) return urlparts[0] + '?' + pars.join('&')
		else return urlparts[0]
	} else return url
}

export function deepCopy<T>(obj: T): T {
	if (obj === null) {
		return obj; // primitive value
	} else {
		if (global.structuredClone)
			return structuredClone(obj);
		else
			return JSON.parse(JSON.stringify(obj));
	}
}

export function deepCopyServerBetsArrayToRouletteHistoryArray(bets: number[][], gamePresets = null, startHistoric: boolean = false): { visible: number, hidden: number }[][] {
	let ret: { visible: number, hidden: number }[][] = [];

	let table = deepCopy(bets);

	for (let i = 0; i < table.length; i++) {
		ret[i] = [];
		for (let j = 0; j < table[i].length; j++) {
			ret[i][j] = { visible: bets[i][j], hidden: 0 };
		}
	}

	if (gamePresets) {
		if (startHistoric) {
			//console.log("this game has presets");
			gamePresets.forEach(element => {
				let singleBet = Math.round(element.bet / Client.logic.getPresetChipAmount(element.fields));
				element.fields.forEach(field => {
					ret[field.X][field.Y].hidden += singleBet * field.A;
				});
			});
		}
		else {
			for (const [key, value] of Object.entries(gamePresets)) {
				//fill board with hidden credits
				Client.logic.betPresets.get(key).fields.forEach(coordinate => {
					ret[coordinate.X][coordinate.Y].hidden += value as number * coordinate.A;
				});
				//store in client
				Client.logic.betPresets.get(key).bet = (value as number) * Client.logic.getPresetChipAmount(Client.logic.betPresets.get(key).fields);
			}
		}

		for (let i = 0; i < table.length; i++) {
			for (let j = 0; j < table[i].length; j++) {
				ret[i][j].visible =  Math.max(0,ret[i][j].visible - ret[i][j].hidden);
			}
		}
	}

	return ret;
}

export function convertHistoryToRouletteHistory(snap: HistorySnapshot, presets): RouletteHistorySnapshot {
	let ret: RouletteHistorySnapshot = omit(snap, 'bets') as RouletteHistorySnapshot;

	let presetsToAssign = new Map<string, { fields: Array<PresetCoordinate>, bet: number }>;
	let hasPresets: boolean = false;

	for (const [key, value] of Object.entries(presets)) {
		let betToAssign: number = 0;
		if (snap.data.betPresets[key]) {
			betToAssign = snap.data.betPresets[key] * Client.logic.getPresetChipAmount(value);
			hasPresets = true;
		}
		presetsToAssign.set(key, { fields: (value as PresetCoordinate[]), bet: betToAssign });
	}
	ret.data.betPresets = presetsToAssign;

	if (hasPresets)
		ret.data.bets = deepCopyServerBetsArrayToRouletteHistoryArray(snap.data.bets, presetsToAssign, true);
	else
		ret.data.bets = deepCopyServerBetsArrayToRouletteHistoryArray(snap.data.bets);

	return ret;
}

function omit(obj, omitKey) {
	return Object.keys(obj).reduce((result, key) => {
		if (key !== omitKey) {
			result[key] = obj[key];
		}
		return result;
	}, {});
}

export function isURL(str) {
	var pattern = new RegExp('/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi');
	return pattern.test(str);
}

export class CrazyMegaEpicScalingStructure {
	public screenW: number;
	public screenH: number;
	public width: number;
	public height: number;
	public zoom: number;
};

export { downscale, quality, SetQuality };
function SetQuality(value: number): void {
	quality = value;
}
var quality: number = 1.0;
var downscale: number = 1.0;

export function GetScalingInfo(): CrazyMegaEpicScalingStructure {
	let wantedGameWidth = 1600 / window.devicePixelRatio;
	let wantedGameHeight = 900 / window.devicePixelRatio;

	let Scale = new CrazyMegaEpicScalingStructure();

	if (!Number.isNaN(Number.parseFloat(GetParameterByName("q"))))
		quality = Number.parseFloat(GetParameterByName("q"));

	Scale.screenW = window.innerWidth;
	Scale.screenH = window.innerHeight;

	let portrait = false;
	try {
		switch (window.orientation) {
			case 0:
			case 180://portrait
				portrait = true;
				break;
			case -90:
			case 90:
			default: //landscape
				portrait = false;
				break;
		}
	}
	catch {
		portrait = false;
	}

	/*if (portrait)
		downscale = Math.min(wantedGameWidth / Scale.screenH, wantedGameHeight / Scale.screenW);
	else
		downscale = Math.min(wantedGameWidth / Scale.screenW, wantedGameHeight / Scale.screenH);
	*/

	Scale.zoom = 1.0 / (window.devicePixelRatio * (Math.max(0.5, downscale) * quality));
	Scale.width = Scale.screenW / Scale.zoom;
	Scale.height = Scale.screenH / Scale.zoom;

	if (Scale.width / Scale.height > Constants.MAIN_SCENE.MAX_SUPPORTED_RATIO) {
		Scale.width = Scale.height * Constants.MAIN_SCENE.MAX_SUPPORTED_RATIO;
	}

	return Scale
}

export function CreateDebugLine(scene: Phaser.Scene, x1: number, y1: number, x2: number, y2: number): Phaser.GameObjects.Line {
	let line = new Phaser.GameObjects.Line(scene, 0, 0, x1, y1, x2, y2, 0xFF0000, 1)
	line.setOrigin(0)
	return line
}

export function getBool(val) {
	return !!JSON.parse(String(val).toLowerCase());
}

export function autoScaleFont(textObj: GameObjects.BitmapText, width: number, height: number): void {
	textObj.setFontSize(Math.min(width / textObj.text.length, height))
}

export function setTextFontScaledToBox(textObj: GameObjects.Text, width: number, height: number): number {
	if (height > 0) textObj.setFontSize(height);
	let size: any = GetTextSize(textObj, [textObj.text])
	let requiredScale = 1.0
	if (width > 0)
		requiredScale = width / size.width;
	if (height > 0)
		requiredScale = Math.min(requiredScale, height / size.height);
	else height = size.height
	textObj.setFontSize(Math.max(1, height * requiredScale))
	return height * requiredScale;
}

export function GetTextSize(text, lines) {
	var canvas = text.canvas;
	var context = text.context;
	var style = text.style;

	var lineWidths = [];
	var maxLineWidth = 0;
	var drawnLines = lines.length;

	if (style.maxLines > 0 && style.maxLines < lines.length) {
		drawnLines = style.maxLines;
	}

	style.syncFont(canvas, context);

	//  Text Width
	for (var i = 0; i < drawnLines; i++) {
		var lineWidth = style.strokeThickness;

		lineWidth += context.measureText(lines[i]).width;

		// Adjust for wrapped text
		if (style.wordWrap) {
			lineWidth -= context.measureText(' ').width;
		}

		lineWidths[i] = Math.ceil(lineWidth);
		maxLineWidth = Math.max(maxLineWidth, lineWidths[i]);
	}

	//  Text Height
	var lineHeight = text.getTextMetrics().fontSize + style.strokeThickness;
	var height = lineHeight * drawnLines;
	var lineSpacing = text.lineSpacing;

	//  Adjust for line spacing
	if (drawnLines > 1) {
		height += lineSpacing * (drawnLines - 1);
	}

	return {
		width: maxLineWidth,
		height: height,
		lines: drawnLines,
		lineWidths: lineWidths,
		lineSpacing: lineSpacing,
		lineHeight: lineHeight
	};
};

export function numToColor(num: number): number {
	/*0 == BLACK, 1 == RED, 3 == GREEN*/
	if (0 == num || 37 == num)
		return Constants.COLORS.GREEN
	else if ((num >= 1 && num <= 10) || (num >= 19 && num <= 28)) {
		if (num % 2 == 0)
			return Constants.COLORS.BLACK
		else
			return Constants.COLORS.RED
	}
	else if ((num >= 11 && num <= 18) || (num >= 29 && num <= 36)) {
		if (num % 2 == 0)
			return Constants.COLORS.RED
		else
			return Constants.COLORS.BLACK
	}
	else
		return -1;
}

export function angle(cx, cy, ex, ey) {
	var dy = ey - cy;
	var dx = ex - cx;
	var theta = Math.atan2(dy, dx); // range (-PI, PI]
	theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
	return theta;
}
export function angle360(cx, cy, ex, ey) {
	var theta = angle(cx, cy, ex, ey); // range (-180, 180]
	if (theta < 0) theta = 360 + theta; // range [0, 360)
	return theta;
}